import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Es difícil de aprender?',
  a: 'No, está diseñado para ser implementado en un fin de semana.'
}, {
  q: '¿Necesito un equipo caro?',
  a: 'Solo tu teléfono actual y buena iluminación natural.'
}, {
  q: '¿Tengo que mostrar mi vida privada?',
  a: 'Absolutamente no. Este método se enfoca 100% en tu autoridad profesional.'
}, {
  q: '¿Cuánto tiempo me quitará al día?',
  a: 'Una vez domines el protocolo, puedes crear tu contenido de la semana en menos de 2 horas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-12 text-navy" data-id="element-16">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, index) => <div key={index} className="border border-gold/20 rounded-sm bg-white overflow-hidden" data-id="element-18">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-19">
                <span className="font-serif text-lg text-navy" data-id="element-20">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-21" />
              </button>

              <AnimatePresence data-id="element-22">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-23">
                    <div className="p-6 pt-0 text-charcoal-light font-light border-t border-gold/10" data-id="element-24">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}